import { Container } from "@/components/atoms";
import { AddClientPanel, PageHeader, PageHeaderV2 } from "@/components/organisms";

export const AddClient = () => {
  return (
    <Container className="mb-12 flex w-full flex-1 flex-col">
      <PageHeaderV2 name="Clients" skipCrumbs={1} />
      <PageHeader.Actions />
      <AddClientPanel />
    </Container>
  );
};
